<div class="modal-header">
  <h3 class="modal-title">{{ title }}</h3>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    data-testid="modal_close_btn"
    (click)="onCancel()"
  ></button>
</div>

<div class="modal-body">
  <div [formGroup]="form">
    <div>
      @if (options?.data?.openedAutomatically) {
        <p>
          You have not saved this search. Saved searches allow you to retrieve previous searches,
          edit and re-run scenarious without entering all the data again.
        </p>
      }
      <p>Saved searches are kept for 180 days.</p>
      <label
        for="searchName"
        class="form-label fw-bold"
      >
        Search name
      </label>
      <p>We recommend using the client's name(s) so you can recognise the search in Saved searches.</p>
      <input
        class="form-control"
        type="text"
        id="searchName"
        formControlName="searchName"
        data-testid="saveSearchModal_searchName"
        maxlength="50"
        [value]=""
      />
      @if (form.get('searchName')?.invalid && form.get('searchName')?.touched && form.get('searchName')?.errors?.required) {
        <div class="invalid-feedback">
          Search name is required
        </div>
      }
      @if (form.get('searchName')?.invalid && form.get('searchName')?.touched && form.get('searchName')?.errors?.maxLength) {
        <div class="invalid-feedback">
          Search name must not be longer than 50 characters
        </div>
      }
    </div>
  </div>
</div>

<div class="modal-footer justify-content-start">
  <div class="d-flex gap-3">
    <button
      type="button"
      class="btn btn-colour-blue-600"
      data-testid="save-btn"
      [disabled]="isSaveDisabled"
      (click)="onSubmit()"
    >
      Save
    </button>
    @if (options?.data?.openedAutomatically) {
      <button
        type="button"
        class="btn btn-colour-white border-colour-grayscale-900"
        data-testid="cancel-btn"
        (click)="onDontSave()"
      >
        Don't save
      </button>
    }
    @else {
      <button
        type="button"
        class="btn btn-colour-white border-colour-grayscale-900"
        data-testid="cancel-btn"
        (click)="onCancel()"
      >
        Cancel
      </button>
    }
  </div>
</div>
